<template>
  <div id="ReportList">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">檢舉內容</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active">檢舉內容</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-banner" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-sm-10">
            <div class="b-filter">
              <el-button
                @click="SGL_Status = -1"
                :class="{ current: SGL_Status == -1 }"
                >全部</el-button
              >
              <el-button
                @click="SGL_Status = 0"
                :class="{ current: SGL_Status == 0 }"
                >未處理</el-button
              >
              <el-button
                @click="SGL_Status = 1"
                :class="{ current: SGL_Status == 1 }"
                >處理中</el-button
              >
              <el-button
                @click="SGL_Status = 2"
                :class="{ current: SGL_Status == 2 }"
                >已處理</el-button
              >
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <div class="card">
              <div class="demo-input-size row margs"></div>
              <div class="card-body">
                <el-form ref="form" label-width="80px" @submit.native.prevent>
                  <el-row>
                    <el-col
                      :md="{ span: 6, offset: 18 }"
                      :sm="{ span: 8, offset: 16 }"
                      :xs="{ span: 14, offset: 10 }"
                    >
                      <el-form-item label="搜尋:">
                        <el-input
                          placeholder="请输入内容"
                          v-model="searchText"
                          clearable
                          @input="searchTextQry"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
                <el-table
                  :data="GetList"
                  v-loading="loading"
                  border
                  row-key="id"
                >
                  <el-table-column label="檢舉人" prop="sgL_UserName">
                  </el-table-column>
                  <el-table-column
                    label="被檢舉人"
                    prop="sgL_ToUserName"
                  ></el-table-column>
                  <el-table-column label="檢舉類型" prop="sgL_ReportType">
                    <template slot-scope="scoped">
                      <span>
                        {{ GetReportType(scoped.row.sgL_ReportType) }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="檢舉原因"
                    prop="sgL_ReportContent"
                  ></el-table-column>
                  <el-table-column label="連結">
                    <template slot-scope="scoped">
                      <a
                        v-if="
                          scoped.row.sgL_Fav_FType == 5 &&
                          !scoped.row.sgL_Fav_FBelongidc
                        "
                        target="_blank"
                        :href="`/feed?id=${scoped.row.sgL_PG_Coid}`"
                      >
                        查看
                      </a>
                      <a
                        v-if="
                          scoped.row.sgL_Fav_FType == 5 &&
                          scoped.row.sgL_Fav_FBelongidc
                        "
                        target="_blank"
                        :href="`/feedHome/feedGroupDetail?id=${scoped.row.sgL_Fav_FBelongidc}&sgL_GroupId=${scoped.row.sgL_PG_Coid}`"
                      >
                        查看
                      </a>
                      <a
                        v-if="scoped.row.sgL_Fav_FType == 7"
                        target="_blank"
                        :href="`/blog/detail?id=${scoped.row.sgL_PG_Coid}`"
                      >
                        查看
                      </a>
                      <router-link
                        v-if="scoped.row.sgL_Fav_FType == 8"
                        target="_blank"
                        :to="{ name:'PointRecordList', query: { id: scoped.row.sgL_PG_Coid } }"
                      >
                        查看
                      </router-link>
                      <a
                        v-if="scoped.row.sgL_Fav_FType == 0"
                        target="_blank"
                        :href="`/albumviewPhotostream?id=${scoped.row.sgL_PG_Coid}`"
                      >
                        查看
                      </a>
                    </template>
                  </el-table-column>
                  <el-table-column label="狀態" prop="sgL_Status">
                    <template slot-scope="scoped">
                      <span
                        v-if="scoped.row.sgL_Status == 0"
                        class="b-unpublished"
                      >
                        未處理
                      </span>
                      <span
                        v-else-if="scoped.row.sgL_Status == 1"
                        class="b-processing"
                      >
                        處理中
                      </span>
                      <span
                        v-else-if="scoped.row.sgL_Status == 2"
                        class="b-published"
                      >
                        已處理
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="舉報時間"
                    prop="sgL_CreateTimeF"
                  ></el-table-column>
                  <el-table-column
                    label="處理時間"
                    prop="sgL_UpdateTimeF"
                  ></el-table-column>
                  <el-table-column
                    label="操作人員"
                    prop="sgL_UpdateName"
                  ></el-table-column>
                  <el-table-column
                    label="備註"
                    prop="sgL_Remark"
                  ></el-table-column>
                  <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="changeStatus(scope.row)"
                      >
                        更改狀態
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- /.card-body -->
            </div>
            <div class="row">
              <div class="col-lg-4 offset-lg-7">
                <!--  引用分页组件 -->
                <pagination
                  v-if="pageParams.pageshow"
                  :currentPage="pageParams.currentPage"
                  :total="pageParams.total"
                  :limit="pageParams.limit"
                  :small="true"
                  @handleCurrentChange="handleCurrentChange"
                  @handleSizeChange="handleSizeChange"
                />
              </div>
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
    <div class="modal fade" id="modal-status--set" aria-modal="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="form-group mb-3">
              <label>#</label>
              <div class="input-group">
                <input
                  type="number"
                  class="form-control"
                  :placeholder="singleData.id"
                  disabled=""
                />
              </div>
            </div>
            <div class="form-group mb-3">
              <label>權限</label>
              <div class="form-group">
                <select
                  class="
                    form-control
                    custom-select
                    select2-no-search select2-hidden-accessible
                  "
                  v-model="singleData.status"
                >
                  <option value="0">未處理</option>
                  <option value="1">處理中</option>
                  <option value="2">已處理</option>
                </select>
              </div>
            </div>
            <div class="form-group mb-3">
              <label>備註</label>
              <div class="input-group">
                <input class="form-control" v-model="singleData.remark" />
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" @click="hide">
              取消
            </button>
            <button
              type="button"
              class="btn btn-primary status--set---success"
              @click="confirm"
            >
              確認
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>
import { Message } from "element-ui";
import pagination from "../common/Page";
export default {
  data() {
    return {
      SGL_Status: -1,
      ReportList: [],
      searchText: "",
      pageParams: {
        pageshow: true,
        currentPage: 1, //當前頁
        total: 0, //總條數
        limit: 10, //顯示條數
      },
      loading: true,
      singleData: {
        id: 0,
        status: 0,
        remark: "",
      },
    };
  },
  created() {
    this.getReportDataList();
  },
  watch: {
    SGL_Status: {
      handler(newvalue, oldvalue) {
        if (newvalue != oldvalue) {
          this.handleCurrentChange(1);
        }
      },
    },
  },
  methods: {
    searchTextQry() {
      this.handleCurrentChange(1);
    },
    getReportDataList() {
      this.loading = true;
      let status = this.SGL_Status;
      if (this.SGL_Status == -1) {
        status = null;
      }
      let params = {
        SGL_Status: status,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
        UserName: this.searchText,
      };
      this.$api.report
        .GetReportData(params)
        .then((res) => {
          if (res.data.success) {
            this.ReportList = res.data.result.items;
            this.pageParams.total = res.data.result.totalCount;
          } else {
            Message({
              type: "error",
              message: res.data.error.message,
            });
          }
        })
        .catch()
        .then((obj) => {
          this.loading = false;
        });
    },
    show() {
      $("#modal-status--set").modal("show");
    },
    hide() {
      $("#modal-status--set").modal("hide");
    },
    initData(item) {
      this.singleData.id = item.id;
      this.singleData.status = item.sgL_Status;
      //this.singleData.remark = item.sgL_Remark;
    },
    changeStatus(item) {
      this.initData(item);
      this.show();
    },
    confirm() {
      let params = {
        id: this.singleData.id,
        sgL_Status: this.singleData.status,
        sgL_Remark: this.singleData.remark,
      };
      this.$api.report.UpdateStatus(params).then((res) => {
        if (res.data.success) {
          this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
          this.hide();
          this.getReportDataList();
        } else {
          this.$message({ type: "error", message: res.data.error.message });
        }
      });
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.getReportDataList();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getReportDataList();
    },
  },
  components: {
    pagination,
  },
  computed: {
    GetList() {
      return this.ReportList;
    },
  },
};
</script>

<style scoped>
.filter .current {
  background-color: #2e3e4a;
  color: #fff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminReport/adminReport.vue